import { inject, Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { finalize } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { LoadingService } from '../spinner/loading.service';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  private readonly loadingService = inject(LoadingService);
  private service_count = 0;

  public static SkipLoadingInterceptorHandling: string = 'x-skip-loading-interceptor-handling';

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (req.headers.get(LoadingInterceptor.SkipLoadingInterceptorHandling)) {
      return next.handle(req);
    }

    this.service_count++;

    this.loadingService.show();
    return next.handle(req).pipe(
      finalize(() => {
        this.service_count--;
        if (this.service_count === 0) {
          this.loadingService.hide();
        }
      }),
    );
  }
}
